import script from "./RuleItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./RuleItem.vue?vue&type=script&setup=true&lang=ts"

import "./RuleItem.vue?vue&type=style&index=0&id=5676a2db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5676a2db"]])

export default __exports__